import React, { FC } from "react";


export const Form: FC<{
    onSubmit?: () => void;
    autoComplete?: boolean;
    children: React.ReactNode;
}> =
    ({ onSubmit, autoComplete, children }) =>
    {
        const $onSubmit: React.FormEventHandler =
            event =>
            {
                onSubmit?.();
                event.preventDefault();
                return false;
            };

        return (
            <form autoComplete={!autoComplete ? "off" : null} onSubmit={$onSubmit} noValidate>
                {children}
            </form>
        );
    };
